/*
 * Filename: panel.js
 * Responsible all cmponent with headding
 * and child components
 */

import React from 'react';
import IconButton from 'material-ui/IconButton';
import IconMenu from 'material-ui/IconMenu';
import MenuItem from 'material-ui/MenuItem';
import classNames from 'classnames';
import Divider from 'material-ui/Divider';
import {getPayerResponsesExportAsCSVAndXLS} from '../modules/Dashboards/actions/StaffDashboardActions';
import moment from 'moment';
import { connect } from 'react-redux';

// Right icon option component
const PayerResponsePanelIconOption = (props) => (
  <IconMenu
    {...props}
    iconButtonElement={
    <IconButton><i className="material-icons">more_vert</i></IconButton>
    }
    targetOrigin={{horizontal: 'right', vertical: 'top'}}
    anchorOrigin={{horizontal: 'right', vertical: 'top'}}
  >
    <MenuItem primaryText="List 1" />
    <MenuItem primaryText="List 2" />
    <MenuItem primaryText="List 3" />
    <MenuItem primaryText="List 4" />
  </IconMenu>
);

const Panel = (props) => {
  const panelClass = classNames ({
    'readmin-panel' : true,
    'righticonmenu': true,
    'body-text-center': props.center
  });

  const exportDataAsCSVOrExcel = (format) => {
    const {FromPayerResponsesDate, ToPayerResponsesDate} = props;
    let searchObj = {    
      contain_filters: {
        fromDate: FromPayerResponsesDate ? moment(FromPayerResponsesDate).format('YYYY-MM-DD') : new Date(),
        toDate: ToPayerResponsesDate ? moment(ToPayerResponsesDate).format('YYYY-MM-DD') : new Date(),        
      }, 
      extension: format
    };
    props.getPayerResponsesExportAsCSVAndXLS(searchObj);
  }

  return (
    <div className={panelClass}>
      <div className="panel-heading">
        <h5>{props.title}</h5>
        { props.righticon ? <PayerResponsePanelIconOption /> : null}

        <div>
          <IconMenu
            anchorOrigin={{ horizontal: "left", vertical: "bottom" }}
            iconButtonElement={
              <IconButton>
                <i className="material-icons">file_download</i>
              </IconButton>
            }
          >
            {
              <span>
                <MenuItem
                  onClick={() => exportDataAsCSVOrExcel("XLS")}
                  primaryText="Excel"
                />
                <Divider />
                <MenuItem
                  onClick={() => exportDataAsCSVOrExcel("CSV")}
                  primaryText="CSV(Comma delimited)"
                />
              </span>
            }
          </IconMenu>
        </div>
      </div>
      <div className="panel-body">
        {props.children}
      </div>
    </div>
  );
}

function mapStateToProps(state) {
 
}

//export default Panel;

export default connect(mapStateToProps, {
  getPayerResponsesExportAsCSVAndXLS})(Panel);



// WEBPACK FOOTER //
// ./src/adminCharts/PayerResponsePanelToolTip.js